export default [
    {
        path: "/login",
        name: "Login",
        component: () => import("../../views/Auth/Login.vue"),
        meta: {
            isAuthPage: true,
        },
    },
    {
        path: "/logout",
        name: "Logout",
        component: () => import("../../views/Auth/Logout.vue"),
        meta: {
            isAuthPage: true,
        },
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("../../views/Auth/Registration.vue"),
        meta: {
            isAuthPage: true,
        },
    },
    {
        path: "/forgot",
        name: "Forgot",
        component: () => import("../../views/Auth/Forgot.vue"),
        meta: {
            isAuthPage: true,
        },
    },
    {
        path: "/reset",
        name: "Reset",
        component: () => import("../../views/Auth/Reset.vue"),
        meta: {
            isAuthPage: true,
        },
    },
    {
        path: "/two-factor",
        name: "TwoFactor",
        component: () => import("../../views/Auth/TwoFactor.vue"),
        meta: {
            isAuthPage: true,
        },
    },
];
